<template>
  <div>
    <el-dialog
      width="1200px"
      class="dialogEDA"
      :close-on-click-modal="false"
      :visible.sync="directoryVisible"
      @close="closeDirectoryDialog"
    >
      <template slot="title">
        <div class="base-flex__cross-center base-font-size__14px">
          <span>当前路径 </span>
          <!--<el-input class="base-width__240" :disabled="true" v-model="pathInput"-->
          <!--          placeholder="请输入内容"></el-input>-->
          <span class="base-width__240">{{ pathInput }}</span>
          <el-button class="base-margin__left-24 base-margin__right-10 buttonBackground_cls" type="text"
                     :disabled="backPageBol"
                     @click="backPage">返回上一页
          </el-button>
          <el-button class="base-margin__left-10 base-margin__right-10 buttonBackground_cls" type="text"
                     @click="returnRoot">返回根目录
          </el-button>
          <span>目录为用户文件储存目录， 支持上传、下载</span>
        </div>
      </template>
      <div class="table">
        <el-table
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleCheckAllChange"
          ref="directoryTable"
          @close="closeDirectoryVisible"
          v-loading="tableLoading"
          max-height="500"
        >
          <!-- 多选框 -->
          <el-table-column type="selection" width="55"></el-table-column>
          <!-- 文件名 -->
          <el-table-column label="文件名">
            <template slot-scope="scope">
              <div v-if="scope.row.is_dir">
                <i class="el-icon-folder-opened base-margin__right-5"></i>
                <el-button class="buttonBackground_cls" style="padding: 0" type="text"
                           @click="openFolder(scope.row.name)">{{
                    scope.row.name
                  }}
                </el-button>
              </div>

              <div v-else>
                <i class="el-icon-tickets base-margin__right-5"></i>
                <span>{{ scope.row.name }}</span>
              </div>
            </template>
          </el-table-column>
          <!-- 文件大小 -->
          <el-table-column label="文件大小" width="200">
            <template slot-scope="scope">{{ sizeFilter(scope.row.size) }}</template>
          </el-table-column>
          <el-table-column label="修改时间" width="280">
            <template slot-scope="scope">
              {{ processTime(scope.row.mod_time) }}
            </template>
          </el-table-column>
          <!--<el-table-column label="操作" width="280">-->
          <!--  <template slot-scope="scope">-->
          <!--    <el-button-->
          <!--      class="buttonBackground_cls"-->

          <!--      type="text"-->
          <!--      @click="changeFilePermission(scope.row)"-->
          <!--    >-->
          <!--      授权编辑-->
          <!--    </el-button>-->
          <!--  </template>-->
          <!--</el-table-column>-->
        </el-table>
      </div>
      <!-- 分页器 -->
      <!--<el-pagination-->
      <!--  align="right"-->
      <!--  @size-change="handleSizeChange"-->
      <!--  @current-change="onCurrentChange"-->
      <!--  :page-sizes="[10, 20, 50, 100]"-->
      <!--  :page-size="pageSize"-->
      <!--  :current-page="currentPage"-->
      <!--  layout="total, sizes, prev, pager, next, jumper"-->
      <!--  :total="tableDataTotal">-->
      <!--</el-pagination>-->
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDirectoryVisible">取 消</el-button>
        <el-button class="dialogTrueCls" type="primary" :loading="submitApprovalLoading" @click="submitApprovalForm">提交审批</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { processTime } from '@/common/utils/utils';
import { postRequest } from '@/common/libs/request';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'downloadFile',
  props: {
    handleClose: Function, // 关闭弹窗函数
  },
  computed: {
    ...mapState(['app']),
    ...mapGetters('app', ['getCurrentProject']),
  },

  data() {
    return {
      checkedFilesList: [], // 所选的文件列表
      directoryVisible: false,
      pathInput: '',
      directoryList: [],
      dirPath: '',
      newLinuxName: '',
      processTime,
      tableData: [],
      submitApprovalLoading: false,
      oldDirPath: '',
      tableLoading: false,
      homePath: '',
      backPageBol: true,
    };
  },

  methods: {
    /**
     * 文件 权限转换
     */
    // changeFilePermission(item) {
    //   this.tableLoading = true;
    //   const dirPath = this.pathInput.split(`/data/home/${this.linuxName}/`)[1] || '';
    //   let pathInput = '';
    //   if (dirPath === '') {
    //     pathInput = item.name;
    //   } else {
    //     pathInput = `${dirPath}/${item.name}`;
    //   }
    //   postRequest('/api/eda/common/project/changeFilePermission', { dirPath: pathInput }).then(() => {
    //     this.tableLoading = false;
    //     this.$message.success('权限转换成功！');
    //   })
    //     .catch(() => {
    //       this.tableLoading = false;
    //     });
    // },

    // 关闭同步服务器文件 同步下载列表
    closeDirectoryDialog() {
      // this.openDownload({});
    },
    /**
     * 分页器钩子函数 页数修改时触发
     */
    // onCurrentChange(page) {
    //   this.currentPage = page;
    //   this.vuePagination();
    // },
    //
    // // 前端分页
    // vuePagination() {
    //   this.tableData = this.directoryList.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
    // },
    // /**
    //  * 每页显示数量钩子函数  每页显示数量修改时触发
    //  */
    // handleSizeChange(pageSize) {
    //   this.currentPage = 1;
    //   this.pageSize = pageSize;
    //   this.vuePagination();
    // },

    /**
     * 提交审批
     */
    submitApprovalForm() {
      const data = JSON.parse(JSON.stringify(this.checkedFilesList));
      this.checkedFilesList = this.checkedFilesList.map(item => `${this.pathInput}/${item}`.replace(/\/\//g, '/'));
      const content = JSON.stringify(this.checkedFilesList);
      this.submitApprovalLoading = true;
      postRequest('/api/eda/common/project/projectApply', {
        scene: 2,
        content,
        describe: '',
        instanceId: this.$route.query.instanceId,
      }).then(() => {
        this.$message.success('提交审批成功!');
        this.closeDirectoryVisible();
      })
        .catch(() => {
          this.checkedFilesList = data;
          this.submitApprovalLoading = false;
        });
    },
    /**
     * 关闭同步服务器文件弹窗
     */
    closeDirectoryVisible() {
      this.submitApprovalLoading = false;
      this.currentPage = 1; // 当前页数
      this.$refs.directoryTable.clearSelection();
      this.directoryVisible = false;
      setTimeout(() => {
        this.$parent.resetApplyList();
      }, 500);
      this.checkedFilesList = [];
    },
    /**
     * 打开文件夹
     */
    openFolder(name) {
      this.pathInput = `${this.pathInput}/${name}`.replace(/\/\//g, '/');
      this.getDirectoryList();
      this.backPageBol = false;
    },

    /**
     * 返回上一页
     */
    backPage() {
      this.pathInput = this.pathInput.substring(0, this.pathInput.lastIndexOf('/'));
      this.oldDirPath = this.pathInput;
      if (this.$route.query.vncUser === 'root') {
        if (this.pathInput === this.homePath) {
          this.backPageBol = true;
        }
      }
      if (this.$route.query.vncUser === 'common') {
        if (this.pathInput === `${this.homePath}/${this.defaultLinuxName}`) {
          this.backPageBol = true;
        }
      }

      if (this.$route.query.vncUser === 'loginSimple') {
        if (this.pathInput === `${this.homePath}`) {
          this.backPageBol = true;
        }
      }
      this.getDirectoryList();
    },

    /**
     * 返回根目录
     */
    returnRoot() {
      if (this.$route.query.vncUser === 'root') {
        this.pathInput = this.homePath;
        this.oldDirPath =  this.homePath;
      }
      if (this.$route.query.vncUser === 'common') {
        this.pathInput = `${this.homePath}/${this.defaultLinuxName}`;
        this.oldDirPath = `${this.homePath}/${this.defaultLinuxName}`;
      }

      if (this.$route.query.vncUser === 'loginSimple') {
        this.pathInput = `${this.homePath}`;
        this.oldDirPath = `${this.homePath}`;
      }
      this.backPageBol = true;
      this.getDirectoryList();
    },
    /**
     * table选择事件
     */
    handleCheckAllChange(val) {
      const nameList = [];
      val.forEach((item) => {
        nameList.push(item.name);
      });
      this.checkedFilesList = nameList;
    },

    /**
     * 获取服务器文件列表
     */
    getDirectoryList() {
      this.checkedFilesList = [];
      const params = {
        instanceId: this.$route.query.instanceId,
        dirPath: this.pathInput
      };
      postRequest('/api/eda/common/project/getDirectoryList', params).then((res) => {
        this.tableData = res?.list?.filter(item => item.name.charAt(0) !== '.') || [];
        this.oldDirPath = this.pathInput;
        // this.tableDataTotal = this.directoryList?.length || 0;
        // this.vuePagination();
        this.directoryVisible = true;
      })
        .catch(() => {
          // 接口错误后，返回默认值path
          this.pathInput = this.oldDirPath;
        });
    },

    /**
     * 打开文件夹弹窗
     */
    openDirectoryDialog(newVal, homePath) {
      this.newLinuxName = newVal;
      this.homePath = homePath;
      this.defaultLinuxName = newVal;
      if (this.$route.query.vncUser === 'root') {
        this.pathInput = this.homePath;
        this.oldDirPath =  this.homePath;
      }
      if (this.$route.query.vncUser === 'common') {
        this.pathInput = `${this.homePath}/${this.defaultLinuxName}`;
        this.oldDirPath = `${this.homePath}/${this.defaultLinuxName}`;
      }
      if (this.$route.query.vncUser === 'loginSimple') {
        this.pathInput = `${this.homePath}`;
        this.oldDirPath = `${this.homePath}`;
      }
      this.getDirectoryList();
    },

    /**
     * 弹窗关闭
     */
    close() {
      this.checkedFilesList = [];
    },

    /**
     * 文件大小过滤
     */
    sizeFilter(value) {
      const text = '';
      const size = value / 1;
      if (size >= 1024 * 1024 * 1024) {
        return `${(size / 1024 / 1024 / 1024).toFixed(2)}G (文件过大，请到使用cosbrower下载)`;
      }
      if (1024 * 1024 < size && size < 1024 * 1024 * 1024) {
        return `${(size / 1024 / 1024).toFixed(2)}M`;
      }
      if (size < 1024 * 1024) {
        return `${(size / 1024).toFixed(2)}KB`;
      }
      return text || '0.00KB';
    },
  },
};

</script>
<style lang="scss" scoped>
.dialogEDA {
  ::v-deep .el-dialog__header {
    text-align: left !important;
  }
}

// table 背景颜色+padding10px
.table {
  background: #fff;
  //padding: 10px;
  // table内容部分下边距和最小高度
  .el-table {
    margin-bottom: 10px;
    min-height: 500px;
    max-height: 500px;
  }
}

.dialogTrueCls {
  background-image: none !important;
}

.buttonBackground_cls {
  background: none !important;
}
</style>
